import {
  CodeOutlined,
  FieldNumberOutlined,
  FieldStringOutlined,
  FileImageOutlined,
} from '@ant-design/icons';
import { type PlaceholderType, PlaceholderTypeEnum } from './types.ts';

interface Props {
  type: PlaceholderType;
}

export function PlaceholderTypeIcon(props: Props) {
  const { type } = props;

  switch (type) {
    case PlaceholderTypeEnum.String:
      return <FieldStringOutlined />;
    case PlaceholderTypeEnum.Number:
      return <FieldNumberOutlined />;
    case PlaceholderTypeEnum.Image:
      return <FileImageOutlined />;
    case PlaceholderTypeEnum.Html:
      return <CodeOutlined />;
    default:
      return null;
  }
}
